import React from "react";
import { useSelector } from "react-redux";
import { useDictionary } from "hooks";
import BasePadding from "@cayuse/shared-react.components.base-padding";
import SectionHeader from "@cayuse/shared-react.components.section-header";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";
import ModificationsList from "components/ModificationsList/ModificationsList";
import { tenantSelectors } from "store/selectors";

import styles from "./styles.css";


const ModificationsMainView = () => {
	const { modificationTypes, subawardModificationTypes } = useSelector(tenantSelectors.tenant);

	const dictionary = useDictionary("modification-types");
	const awardDictionary = useDictionary("modification-types.award");
	const subawardDictionary = useDictionary("modification-types.subaward");

	return (
		<div id={styles.resolutions}>
			<SectionHeader header={dictionary.manageModifications} />
			<VerticalSpacing>
				<BasePadding>
					<ModificationsList
						modificationTypes={modificationTypes}
						dictionary={dictionary}
						listName={"modificationTypes"}
						instanceDictionary={awardDictionary}
					/>
				</BasePadding>
			</VerticalSpacing>
			<VerticalSpacing>
				<BasePadding>
					<ModificationsList
						modificationTypes={subawardModificationTypes}
						dictionary={dictionary}
						listName={"subawardModificationTypes"}
						instanceDictionary={subawardDictionary}
					/>
				</BasePadding>
			</VerticalSpacing>
		</div>
	);
};

export default ModificationsMainView;
